export const phoneLink = (p) => `tel:${p}`;
export const PHONE_PATIENT_HELP_RAW = '18442656444';
export const PHONE_PATIENT_HELP = '1 (844) 265 - 6444';
export const PHONE_PATIENT_HELP_AUTHENTICATED = '1 (844) 265 - 6444';
export const PHONE_PATIENT_HELP_MOBILE = '1 (844) 265 - 6444';
export const PHONE_PATIENT_HELP_MOBILE_NO_SPACE = '18442656444';
export const PHONE_PATIENT_HELP_MOBILE_AUTHENTICATED = '1 (844) 265 - 6444';
export const PHONE_PATIENT_HELP_MOBILE_AUTHENTICATED_NO_SPACE = '18442656444';
export const PHONE_PATIENT_HELP_OTP = '1 (844) 265 - 6444';
export const PHONE_PHARMACIST_HELP_RAW = '18005360352';
export const PHONE_PHARMACIST_HELP = '1 (800) 536 - 0352';
export const PHONE_PROVIDER_HELP_RAW = '18008738104';
export const PHONE_PROVIDER_HELP = '1 (800) 873 - 8104';
export const PHONE_PATIENT_BLINK_CARD_HELP = '1 (844) 265 - 6444';
export const PHONE_PHARMACY_TRANSFER_HELP = '1 (844) 265 - 6444';
export const PHONE_MDV_V2_HELP = '1 (844) 265 - 6444';
export const PHONE_MDV_V2_HELP_NO_SPACE = '18442656444';
export const PHONE_PATIENT_ACCESS_PROGRAM = '1 (844) 265 - 6444';
export const PHONE_TREAT_TYPE_TWO = '1 (844) 265 - 6444';
export const PHONE_ROCHE_PARTNERSHIP = '1 (844) 265 - 6444';
export const PHONE_DESKTOP_BANNER_UNAUTHENTICATED = '1 (844) 265 - 6444';
export const PHONE_DESKTOP_CHECKOUT_HELP = '1 (844) 265 - 6444';
export const PHONE_DIGITAL_PATIENT_CHECKOUT = '1 (844) 265 - 6444';
export const PHONE_BLINK_HEALTH_PHARMACY = '1 (314) 356 - 2943';
export const PHONE_BLINK_HEALTH_PHARMACY_FAX = '1 (314) 558 - 2641';
export const PHONE_PHARMACY_SUPPORT_NIMBUS = '1 (844) 737 - 5641';
export const PHONE_TELEMED_HELP = '1 (844) 265 - 6444';
export const PHONE_HOME_DELIVERY_HELP = '1 (844) 312 - 5905';
export const PHONE_TELESALES = '1 (833) 844 - 9621';
export const PHONE_TELESALES_HEADER = '1 (844) 265 - 6444';
export const PHONE_SUBSCRIPTIONS = '1 (844) 265 - 6444';
export const PHONE_SUBSCRIPTIONS_NO_SPACE = '18442656444';
export const PHONE_TELESALES_MARKET_TEST = '1 (833) 844 - 9621';
export const PHONE_TELEHEALTH_TELESALES = '1 (855) 712-8123';
export const PHONE_MAGIC_CARD_HELP_UNAUTHENTICATED = '1 (844) 374 - 8020';
export const PHONE_MAGIC_CARD_HELP_UNAUTHENTICATED_RAW = '18443748020';
export const PHONE_REVERIE_PATIENT_AUTHENTICATED = '1 (844) 963 0320';
export const PHONE_REVERIE_PATIENT_AUTHENTICATED_RAW = '18449630320';
export const PHONE_SPANISH_MAGIC_CARD = '1 (833) 321-3640';
